import { useLocation } from 'react-router-dom';
import SEO from './SEO';

const PUBLIC_ROUTES = new Set([
  '/',
  '/subscription',
  '/kontaktai',
  '/taisykles',
  '/privatumas',

  // Stage 7 — Age SEO Hubs
  '/zaidimai-ikimokyklinukams',
  '/zaidimai-pradinukams',

  // SEO landing pages
  '/mokomieji-zaidimai',
  '/matematikos-zaidimai',
  '/skaitymo-zaidimai',
  '/lietuviu-kalbos-zaidimai',
  '/logopediniai-zaidimai',

  // Stage 6B — Topic SEO Hubs
  '/loginis-mastymas',
  '/skaiciai-ir-skaiciavimas',
  '/zodynas',
  '/teksto-supratimas',
  '/demesys',
]);

const RouteSEO = () => {
  const location = useLocation();

  const pathname =
    location.pathname.replace(/\/+$/, '') || '/';

  const isPublic = PUBLIC_ROUTES.has(pathname);

  if (isPublic) {
    return null;
  }

  return (
    <SEO
      title="SmartPanda"
      description="SmartPanda – interaktyvi mokymosi platforma vaikams."
      canonical={pathname}
      robots="noindex, follow"
      includeOrganizationSchema={false}
    />
  );
};

export default RouteSEO;
